import { InlineProductsById } from '../CommonScanSchemas';
import { Scope } from '../OptimizedValueExpressions';
import { initCommonDeoptimizedScanPartProps, initDeoptimizedLineItem, ScanLineItem, ScanOption } from '../ScanRoot';
import { getOptimizedOption, ScanOptionOptimized } from '../ScanRootOptimized';
import { ScanTemplateLineItem, ScanTemplateOption } from '../ScanTemplateRoot';

/** `initDeoptimizedLineItem`, stamped with `agentUpdatedAt` when an agent made the change. */
export const initDeoptimizedStandardLineItem = (
  template: ScanTemplateLineItem,
  inlineProductsById: InlineProductsById,
  now: number = Date.now(),
  agentUpdatedAt?: number,
): ScanLineItem => ({
  ...initDeoptimizedLineItem(template, now, inlineProductsById),
  ...(agentUpdatedAt && { agentUpdatedAt }),
});

export const initDeoptimizedStandardOption = (
  template: ScanTemplateOption,
  inlineProductsById: InlineProductsById,
  now: number = Date.now(),
  agentUpdatedAt?: number,
): ScanOption => ({
  ...initCommonDeoptimizedScanPartProps(template, now),
  ...(agentUpdatedAt && { agentUpdatedAt }),
  lineItems: [],
  // (template.lineItemTemplates || [])
  //   .filter(isTemplatePartIncludedByDefault)
  //   .map(lineItemTemplate => initDeoptimizedStandardLineItem(lineItemTemplate, inlineProductsById, now))
});

// export const initStandardOptionFromTemplate = (template: ScanTemplateOption, parentScope: Scope, inlineProductsById: InlineProductsById, now: number = Date.now()): ScanOptionOptimized =>
//   recalculateAllScanOptionValues(
//     getOptimizedOption(initDeoptimizedStandardOption(template, inlineProductsById, now), template, parentScope),
//     parentScope
//   )

export const initStandardOptionFromTemplate = (
  template: ScanTemplateOption,
  parentScope: Scope,
  inlineProductsById: InlineProductsById,
  now: number = Date.now(),
  agentUpdatedAt?: number,
): ScanOptionOptimized => getOptimizedOption(initDeoptimizedStandardOption(template, inlineProductsById, now, agentUpdatedAt), template, parentScope);
